import { useState } from 'react'
import { Close, InformationCircleContained } from 'blaze-ui/icons'
import Styles from './useFreePlanBanner.module.scss'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'

const DISMISSAL_KEY = 'free-plan-banner-dismissed'

export const useFreePlanBanner = () => {
  const workspace = useCurrentWorkspace()
  const { isIOSNative } = useResponsiveDesign()
  const isAPMobileWeb = useAPMobileWeb()
  const [localDismissed, setLocalDismissed] = useState(false)

  const dismissed = localDismissed || !!localStorage.getItem(DISMISSAL_KEY)

  const hideBanner =
    isIOSNative ||
    isAPMobileWeb ||
    !workspace ||
    !workspace.is_virtual_marketer ||
    !workspace.is_ap_freemium ||
    dismissed

  const freePlanBanner = (
    <div className={Styles.container}>
      <InformationCircleContained color="var(--light-100)" size={24} />
      <div className={Styles.message}>
        <Text variant="secondary" color="var(--light-100)">
          You're now on the Free Plan. Your previously created posts will continue to be published as scheduled.
        </Text>
      </div>
      <div className={Styles.close}>
        <Button
          aria-label="Dismiss Banner"
          onPress={() => {
            localStorage.setItem(DISMISSAL_KEY, 'true')
            setLocalDismissed(true)
          }}
          variant="tertiary"
          size="xs"
        >
          <Close size={16} color="var(--light-100)" />
        </Button>
      </div>
    </div>
  )

  return {
    showBanner: !hideBanner,
    freePlanBanner,
  }
}
